export default __webpack_public_path__ + "static/header_mendixworld-45bc6411eaf3d9a753c7290dab09f7fe.png";